module.exports = __webpack_public_path__ + "img/lens-160-plus-04.16180740.png";